module.exports = __webpack_public_path__ + "media/images/nav/icon_4-12f3ed62a0b0a09fb93ddd6a2030c6c2.svg";